import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import style from "./character2.module.scss";
import Character2 from "./character2";
import { HomeItem } from "../../../../../models/home-rows";

type CharacterSwiperProps = {
  homeItem: HomeItem;
};

function CharacterSwiper({ homeItem }: CharacterSwiperProps) {
  const breakpoints = {
    2000: {
      slidesPerView: 13.5,
      spaceBetween: 0
    },
    1800: {
      slidesPerView: 12.5,
      spaceBetween: 0
    },
    1600: {
      slidesPerView: 11.5,
      spaceBetween: 0
    },
    1400: {
      slidesPerView: 10.5,
      spaceBetween: 0
    },

    1200: {
      slidesPerView: 8.5,
      spaceBetween: 0
    },

    768: {
      slidesPerView: 5.5,
      spaceBetween: 0
    },

    400: {
      slidesPerView: 3.5,
      spaceBetween: 0
    },

    200: {
      slidesPerView: 3.5,
      spaceBetween: 0
    }
  };
  return (
    <>
      <Swiper
        className={style.swiper}
        autoHeight={false}
        slidesPerView={8.5}
        slidesPerGroup={1}
        dir="rtl"
        breakpoints={breakpoints}
      >
        {/*single row*/}
        {homeItem.categories.length &&
          homeItem.categories.map((character, index) => (
            <SwiperSlide key={"swip-prod-" + character.id} virtualIndex={index}>
              <div className={style.character}>
                <Character2 character={character} key={character.id} />
              </div>
            </SwiperSlide>
          ))}
        {/*double row*/}
        {/* {homeItem?.categories?.length &&
          homeItem.categories
            .reduce((acc, character, index) => {
              if (index % 2 === 0) acc.push([]);
              acc[acc.length - 1].push(
                <div className={style.character}>
                  <Character2 character={character} key={character.id} />
                </div>
              );
              return acc;
            }, [])
            .map((pair, index) => (
              <SwiperSlide key={"swiper-row-" + index}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  {pair}
                </div>
              </SwiperSlide>
            ))} */}
      </Swiper>
    </>
  );
}

export default CharacterSwiper;
